import { BuskerStore } from "@/types/store";
import { Busker } from "@/types/type";
import { create } from "zustand";

export const useBuskerStore = create<BuskerStore>((set) => ({
  buskers: [],
  selectedBusker: null,
  setBuskers: (buskers: Busker[]) => set({ buskers }),
  setSelectedBusker: (busker: Busker) => set({ selectedBusker: busker }),
  clearSelectedBusker: () => set({ selectedBusker: null }),
}));
